import type { DefaultFeedTabKey } from '@/core/models/preferences';

export interface FeedVisit {
  tab: DefaultFeedTabKey;
  offset: number;
  anchor?: string;
  delta?: number;
}
const key = (owner: string) => `truxsocial:feed-visit:${owner}`;
export function readFeedVisit(owner: string): FeedVisit | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key(owner)) ?? 'null');
    return value &&
      ['following', 'for-you', 'trending', 'discover'].includes(value.tab) &&
      Number.isFinite(value.offset) &&
      value.offset >= 0
      ? value
      : null;
  } catch {
    return null;
  }
}
export function saveFeedVisit(owner: string, visit: FeedVisit | null) {
  try {
    if (visit) sessionStorage.setItem(key(owner), JSON.stringify(visit));
    else sessionStorage.removeItem(key(owner));
  } catch {
    /* Browser storage may be unavailable. */
  }
}
